import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import BannerImage from "../../assets/anell360/swimmers.jpeg";
import Img1 from "../../assets/anell360/horse1.jpeg";

import Img8 from "../../assets/carousel/commday.jpg";
import Art1 from "../../assets/anell360/art1.jpeg";
import Art2 from "../../assets/anell360/art2.jpeg";
import Art3 from "../../assets/anell360/art3.jpeg";


import { EnrichmentProgramsGallery, ArtCraftGallery, AfroDanceGallery, KarateGallery } from '../../utils/galleryAssets';
import Img2 from "../../assets/anell360/swim2.jpeg";
import Img3 from "../../assets/anell360/swim3.jpeg";
import Img4 from "../../assets/anell360/swim4.jpeg";
import Img6 from "../../assets/anell360/swim6.jpeg";

// import Exc4 from "../../assets/anell360/exc4.jpeg";

import { MdAdd, MdRemove, MdSportsSoccer, MdPalette, MdLightbulb, MdMusicNote, MdBrush, MdAutoFixHigh, MdPool, MdFitnessCenter } from 'react-icons/md';
import { BsWhatsapp } from "react-icons/bs";
import { Link } from 'react-router-dom';

const CollageGallery = ({ images }) => {
    if (!images || images?.length === 0) {
        return (
            <div className="h-[300px] lg:h-[350px] bg-gray-50 rounded border-2 border-dashed border-gray-200 flex items-center justify-center">
                <span className="text-gray-400 font-medium">Coming Soon</span>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {images.map((img, index) => (
                <div 
                    key={index} 
                    className="h-48 md:h-64 rounded-xl overflow-hidden shadow-md transform hover:scale-[1.02] transition-transform duration-500"
                >
                    <img src={img} className="w-full h-full object-cover" alt={`Activity ${index + 1}`} />
                </div>
            ))}
        </div>
    );
};

const AccordionItem = ({ title, content, isOpen, onClick, images, icon: Icon }) => {
    return (
        <div className="border-b border-gray-100 last:border-0">
            <button
                className={`w-full flex items-center justify-between py-6 px-6 lg:px-12 transition-all duration-500 ${isOpen ? 'bg-[#021d53] text-white' : 'bg-white text-[#021d53] hover:bg-gray-50'}`}
                onClick={onClick}
            >
                <div className="flex items-center gap-4 lg:gap-6">
                    {Icon && <Icon className={`text-2xl lg:text-3xl ${isOpen ? 'text-white' : 'text-[#ed3137]'}`} />}
                    <span className="text-lg md:text-2xl font-black uppercase tracking-tight text-left leading-tight">{title}</span>
                </div>
                {isOpen ? <MdRemove className="text-3xl" /> : <MdAdd className="text-3xl" />}
            </button>
            <div 
                className={`overflow-hidden transition-all duration-700 ease-in-out ${isOpen ? 'max-h-[2500px] opacity-100' : 'max-h-0 opacity-0'}`}
            >
                <div className="p-6 lg:p-12 bg-white">
                    <div className="flex flex-col lg:flex-row gap-10 items-center">
                        <div className={images?.length > 0 ? "lg:w-1/2" : "w-full"}>
                            <p className="text-lg md:text-xl text-gray-600 leading-relaxed font-medium">
                                {content}
                            </p>
                        </div>
                        {images?.length > 0 && (
                            <div className="lg:w-1/2 w-full">
                                <CollageGallery images={images} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ExtraCurricular = () => {
    const location = useLocation();
    const [openIndex, setOpenIndex] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const activities = [
        {
            title: "Sports & Physical Development",
            icon: MdSportsSoccer,
            content: "Physical education and sports are integral to student development. Inter-house competitions, athletics, and team sports promote discipline, teamwork, endurance, and sportsmanship. Participation builds both physical strength and character.",
            images: [Img1, Img2, Img3, Img4]
        },
        {
            title: "Arts & Talent Development",
            icon: MdPalette,
            content: "Creative showcases, music performances, dance presentations, and art exhibitions provide platforms for students to shine. Talent development initiatives help identify individual strengths and nurture them with intention and care.",
            images: [Art1, Art2, Art3, Img8]
        },
        {
            title: "Enrichment Programmes",
            icon: MdLightbulb,
            content: "Educational excursions, career talks, workshops, and skill-building sessions broaden learners’ perspectives. These experiences connect classroom learning to the real world and inspire ambition.",
            images: EnrichmentProgramsGallery
        },
        {
            title: "Music Club",
            icon: MdMusicNote,
            content: "The Music Club provides a space for learners to explore rhythm, melody, and performance. Through vocal training, instrument practice, and group rehearsals, students build confidence, discipline, and an appreciation for musical expression while learning the value of collaboration.",
            images: []
        },
        {
            title: "Art and Craft",
            icon: MdBrush,
            content: "Art and Craft sessions encourage creativity, imagination, and attention to detail. Learners experiment with different materials and techniques, developing fine motor skills and self-expression while bringing their ideas to life in meaningful and practical ways.",
            images: ArtCraftGallery
        },
        {
            title: "Afro Dance",
            icon: MdAutoFixHigh,
            content: "Afro Dance celebrates culture, rhythm, and movement. This high-energy activity strengthens coordination, stamina, and confidence, while helping learners connect with African heritage through expressive and dynamic performances.",
            images: AfroDanceGallery
        },
        {
            title: "Swimming",
            icon: MdPool,
            content: "Swimming develops endurance, coordination, and water safety skills. Beyond physical fitness, it nurtures focus, resilience, and self-assurance as learners steadily improve their technique and confidence in the water.",
            images: [Img3, Img4, Img2, Img6]
        },
        {
            title: "Karate",
            icon: MdFitnessCenter,
            content: "Karate instills discipline, respect, and self-control. Through structured training, learners develop strength, balance, and mental focus while building confidence and learning the importance of perseverance and personal responsibility.",
            images: KarateGallery
        }
    ];

    return (
        <div className="font-sans text-gray-900 bg-white min-h-screen">
            

            {/* Hero Section */}
            <div className="relative h-[55vh] lg:h-[70vh] w-full flex items-center justify-center overflow-hidden bg-[#021d53]">
                <img 
                    src={BannerImage} 
                    alt="Extra-Curricular Banner" 
                    className="absolute inset-0 h-full w-full object-cover opacity-40 scale-105"
                />
                <div className="relative z-10 text-center px-5 max-w-4xl">
                    <h1 className="text-4xl md:text-7xl font-black text-white mb-6 uppercase tracking-tighter drop-shadow-2xl">
                        Extra-Curricular Activities
                    </h1>
                    <div className="w-24 h-2 bg-[#ed3137] mx-auto mb-8"></div>
                    <p className="text-xl md:text-2xl text-white font-medium max-w-2xl mx-auto leading-relaxed opacity-90">
                        Broadening horizons through discovery, skill-building, and artistic expression.
                    </p>
                </div>
            </div>

            {/* Content Section */}
            <section className="py-20 lg:py-32 max-w-[1440px] mx-auto px-5 md:px-10 lg:px-20">
                <div className="mb-16">
                    <h2 className="text-3xl md:text-5xl font-black text-[#021d53] mb-6">Explore Our Activities</h2>
                    <div className="w-16 h-1 bg-[#ed3137] mb-8"></div>
                    <p className="text-xl text-gray-600 max-w-3xl leading-relaxed">At Anell, we believe in nurturing the whole child. Our extra-curricular programme is designed to help every learner discover their passion and excel beyond the classroom.</p>
                </div>

                <div className="bg-white rounded shadow-[0_10px_50px_rgba(0,0,0,0.05)] overflow-hidden border border-gray-100">
                    {activities.map((activity, index) => (
                        <AccordionItem 
                            key={index}
                            title={activity.title}
                            icon={activity.icon}
                            content={activity.content}
                            images={activity.images}
                            isOpen={openIndex === index}
                            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                        />
                    ))}
                </div>
            </section>

            {/* Quote Section */}
            <section className="py-24 bg-gray-50 border-y border-gray-100">
                <div className="max-w-4xl mx-auto px-5 text-center">
                    <p className="text-2xl md:text-4xl font-light italic text-[#021d53] leading-relaxed">
                        "Enabling students to think beyond themselves and contribute positively to society through character and talent."
                    </p>
                </div>
            </section>

            <Footer />
             
        </div>
    );
};

export default ExtraCurricular;
